'use client';

import { SanityClient } from '@sanity/client';
import { createContext } from 'react';

type ContextValue = {
  client: SanityClient | null;
};

export const SanityDraftClientContext = createContext<ContextValue>({
  client: null
});
